module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.5506b86a.svg";